/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 11:15:00 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-26 10:59:37
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" />
    <div class="docs">
      <h1>{{ st('helpDocs.whyJoin.h1') }}</h1>
      <h2>{{ st('helpDocs.whyJoin.h2Benefit') }}</h2>
      <p>{{ st('helpDocs.whyJoin.pBenefit') }}</p>
      <h2>{{ st('helpDocs.whyJoin.h2One') }}</h2>
      <p>{{ st('helpDocs.whyJoin.pOne') }}</p>
      <h2>{{ st('helpDocs.whyJoin.h2Two') }}</h2>
      <p>{{ st('helpDocs.whyJoin.pTwo') }}</p>
      <h2>{{ st('helpDocs.whyJoin.h2Three') }}</h2>
      <p>{{ st('helpDocs.whyJoin.pThree') }}</p>
      <h2>{{ st('helpDocs.whyJoin.h2Four') }}</h2>
      <p>{{ st('helpDocs.whyJoin.pFourA') }}</p>
      <p>{{ st('helpDocs.whyJoin.pFourB') }}</p>
    </div>
  </div>
</template>

<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
import { useSellerI18n } from '@/composables/useSellerI18n'

const { st } = useSellerI18n()
</script>
